import { ObstructionsDataIn } from './types';
import { RecordData } from '../../helpers-classes';

export const obstructionsData = (dataIn: ObstructionsDataIn = null): ObstructionsDataIn => {
	const rd = new RecordData<ObstructionsDataIn>(dataIn);

	const record: ObstructionsDataIn = {
		defaultIslandId: rd.useNewOrDefault<string | null>('defaultIslandId', null),
		children: dataIn?.children ?? []
	};

	return record;
};
